import Logo from "@/components/feature/Logo";

export default function HeroSection() {
  return (
    <section
      className="relative bg-cover bg-center bg-no-repeat bg-fixed"
      style={{
        backgroundImage:
          "url('/images/header-background.jpg')",
      }}
    >
      <div className="absolute inset-0 bg-black/30"></div>
      <div className="relative max-w-[1400px] mx-auto px-4 py-20 md:py-28 flex items-center justify-center">
        <div className="text-center">
          <Logo variant="light" size="lg" className="scale-150 md:scale-[2]" />
        </div>
      </div>
    </section>
  );
}